/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScopeIsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ScopeIsQueryOperator");
    }

    getFixupPrototypeFunction() { return ScopeIsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ScopeIsQueryOperator>): ScopeIsQueryOperator {
        let obj = Object.assign(new ScopeIsQueryOperator(), model);
        ScopeIsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScopeIsQueryOperator>): ScopeIsQueryOperator {
        if (!model) return null;
        return ScopeIsQueryOperator.newInstance(<ScopeIsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScopeIsQueryOperator) {
        if (!obj) return;

        models.ScopeIsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScopeIsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScopeIsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.scope) {
            models.QueryOperator.fixupPrototype(this.scope);
        }
    }

    /**
     * Query operator to include in the scope
     */
    scope: models.QueryOperator;

}
